<template>
  <div>
    <div class="container-fluid mt--6x">
      <div class="card">
        <div class="card-header border-0">
        </div>
        <div class="row starter-page">
          <div class="container-fluid">
            <el-table
                class="table-responsive table-flush"
                header-row-class-name="thead-light"
                row-key="id"
                :data="calificaciones"
            >
              <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  v-bind="column"
              >
              </el-table-column>
            </el-table>
            <br/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import {Dropdown, DropdownItem, DropdownMenu, Table, TableColumn, Tooltip} from "element-ui";
import axios from "axios";

export default {
  name: "ListCalificacion",
  components: {
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      calificaciones: [],
      tableColumns: [
        {
          prop: 'week',
          label: 'Semana',
          minWidth: 200,
          sortable: false
        },
        {
          prop: 'question',
          label: 'Pregunta',
          minWidth: 280,
          sortable: false
        },
        {
          prop: 'answer',
          label: 'Respuesta',
          minWidth: 220,
          sortable: false
        },
        {
          prop: 'rating',
          label: 'Calificación',
          minWidth: 180,
          sortable: false
        },
        {
          prop: 'created_at',
          label: 'F.Registro',
          minWidth: 120,
          sortable: false
        }
      ],
    }
  },
  created() {
    this.fetchCalifications()
  },
  methods: {
    async fetchCalifications() {
      try {
        const response = await axios.get('calificaciones/week')
        this.calificaciones = response.data.data
      } catch (e) {
      }
    }
  }
}
</script>

<style scoped>

</style>